import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=21115cf2"
import script from "./Pricing.vue?vue&type=script&lang=ts"
export * from "./Pricing.vue?vue&type=script&lang=ts"
import style0 from "./Pricing.vue?vue&type=style&index=0&id=21115cf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports